import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";

import AdminLogin from "@/pages/AdminLogin";
import HomePage from "@/pages/HomePage";
import AdminPanelV2 from "@/pages/AdminPanelV2";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminPanelV2 />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" richColors />
    </div>
  );
}

export default App;
